import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { EmailTemplateForm } from '@/components/forms/EmailTemplateForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateEmailTemplatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/system-settings/email-template')
  }

  const handleCancel = () => {
    navigate('/system-settings/email-template')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Email Template</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Create a new email notification template
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <EmailTemplateForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
